// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getString, LocaleString } from '@nackle/intl-tools';
import LanguagePicker from '../c-language-picker';
import Error404 from '../../assets/images/Error404.png';
import './error.less';


export default class ErrorBoundary extends Component {
    constructor( props ) {
        super( props );
        const { error } = props;

        switch ( error ) {
            case 'path':
                this.state = {
                    hasError: true,
                    errorText: <LocaleString code="errors.content.path" TextComponent="p" />
                };
                break;
            default:
                this.state = {
                    hasError: false,
                    errorText: ''
                };
                break;
        }
    }

    componentDidCatch( error, info ) {
        console.error( 'errors in error boundary:', error, info );
        this.setState(
            {
                hasError: true,
                errorText: getString( 'errors.content.generic' )
            }
        );

    }

    render() {
        const { hasError, errorText } = this.state;
        const { className } = this.props;

        if ( hasError ) {
            return (
                <div className={ `${ className } error-page` }>
                    <div className="error-container">
                        <LanguagePicker />
                        <LocaleString className="form-heading" code="errors.content.uhoh" TextComponent="h1" />
                        <img alt='' src={ Error404 } />
                        <LocaleString code="errors.content.connect" TextComponent="h3"/>
                        { errorText }
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.oneOfType( [
        PropTypes.arrayOf( PropTypes.node ),
        PropTypes.node
    ] )
};